module.exports = __webpack_public_path__ + "img/kaifaz.1f14b5b5.png";